import type { CSSProperties, ReactNode } from 'react';
import { INK } from './theme.ts';

/**
 * Content strings carry `**bold**`; nothing else. Titles bold in the accent
 * colour, body copy bolds in ink — pass `strongColor` to choose.
 */
export function rich(text: string | undefined, strongColor: string = INK): ReactNode {
  if (!text) return null;
  if (!text.includes('**')) return text;
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <strong key={i} style={{ color: strongColor, fontWeight: 800 }}>
        {part}
      </strong>
    ) : (
      part
    ),
  );
}

export function Rich({ text, strongColor, style, className }: { text?: string; strongColor?: string; style?: CSSProperties; className?: string }) {
  if (!text) return null;
  return (
    <span className={className} style={style}>
      {rich(text, strongColor)}
    </span>
  );
}

/** `**` markers stripped, for places that cannot render markup (aria labels, document.title) */
export const plain = (text: string | undefined): string => (text ?? '').replace(/\*\*/g, '');
